/**
 * Created by lihanying on 2017/6/20.
 */

import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { GETPORTALSUCCESS } from './constants'

export const getPortalSuccess = (payload) => {
  return {
    type: GETPORTALSUCCESS,
    payload,
  }
}

export function fetchPortal() {
  return (dispatch, getState) => {
    const endpoint = API_DOMAIN + '/LoginApi/Qr'
    fetch(endpoint)
      .then((res) => res.ok && res.json())
      .then((data) => dispatch(getPortalSuccess(data)))
  }
}



// WEBPACK FOOTER //
// ./src/containers/Portal/action.js